var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 3.66663C3.33301 4.21891 2.88529 4.66663 2.33301 4.66663C1.78072 4.66663 1.33301 4.21891 1.33301 3.66663C1.33301 3.11434 1.78072 2.66663 2.33301 2.66663C2.88529 2.66663 3.33301 3.11434 3.33301 3.66663ZM2.33301 4.33329C2.7012 4.33329 2.99967 4.03482 2.99967 3.66663C2.99967 3.29844 2.7012 2.99996 2.33301 2.99996C1.96482 2.99996 1.66634 3.29844 1.66634 3.66663C1.66634 4.03482 1.96482 4.33329 2.33301 4.33329Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 3.16663C5.05687 3.16663 4.83301 3.39048 4.83301 3.66663C4.83301 3.94277 5.05687 4.16663 5.33301 4.16663H14.333C14.6091 4.16663 14.833 3.94277 14.833 3.66663C14.833 3.39048 14.6091 3.16663 14.333 3.16663H5.33301Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 7.16663C5.05687 7.16663 4.83301 7.39048 4.83301 7.66663C4.83301 7.94277 5.05687 8.16663 5.33301 8.16663H14.333C14.6091 8.16663 14.833 7.94277 14.833 7.66663C14.833 7.39048 14.6091 7.16663 14.333 7.16663H5.33301Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 11.1666C5.05687 11.1666 4.83301 11.3905 4.83301 11.6666C4.83301 11.9428 5.05687 12.1666 5.33301 12.1666H14.333C14.6091 12.1666 14.833 11.9428 14.833 11.6666C14.833 11.3905 14.6091 11.1666 14.333 11.1666H5.33301Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 7.66663C3.33301 8.21891 2.88529 8.66663 2.33301 8.66663C1.78072 8.66663 1.33301 8.21891 1.33301 7.66663C1.33301 7.11434 1.78072 6.66663 2.33301 6.66663C2.88529 6.66663 3.33301 7.11434 3.33301 7.66663ZM2.99967 7.66663C2.99967 8.03482 2.7012 8.33329 2.33301 8.33329C1.96482 8.33329 1.66634 8.03482 1.66634 7.66663C1.66634 7.29844 1.96482 6.99996 2.33301 6.99996C2.7012 6.99996 2.99967 7.29844 2.99967 7.66663Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 11.6666C3.33301 12.2189 2.88529 12.6666 2.33301 12.6666C1.78072 12.6666 1.33301 12.2189 1.33301 11.6666C1.33301 11.1143 1.78072 10.6666 2.33301 10.6666C2.88529 10.6666 3.33301 11.1143 3.33301 11.6666ZM2.33301 12.3333C2.7012 12.3333 2.99967 12.0348 2.99967 11.6666C2.99967 11.2984 2.7012 11 2.33301 11C1.96482 11 1.66634 11.2984 1.66634 11.6666C1.66634 12.0348 1.96482 12.3333 2.33301 12.3333Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleList);
export default __webpack_public_path__ + "static/media/circleList.c2a1085cd4a9120e11c3d967b1c2b8b5.svg";
export { ForwardRef as ReactComponent };